module.exports = __webpack_public_path__ + "static/media/Aquarius-RegularMono.bcfa907c.ttf";